import { Global } from "@emotion/react";
import { SnackbarProvider, SnackbarProviderProps } from "notistack";

// container root class name
const containerRoot = "LxSnackbarProvider";

/**
 * The provider for all snackbars.
 *
 * @package Snackbar
 */
export function LxSnackbarProvider(props: SnackbarProviderProps) {
  return (
    <>
      <Global
        styles={{
          [`.${containerRoot}`]: {
            top: "170px !important",
          },
        }}
      />
      <SnackbarProvider
        classes={{
          containerRoot,
        }}
        maxSnack={3}
        autoHideDuration={5000}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        {...props}
      />
    </>
  );
}
